export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/e2d115f81737d89f246de6338bc29dde.png";